export enum GradeCalculationTagKey {
  DEFAULT = 'default',
  HIGH = 'high',
  HIGHER = 'higher',
  LOWER = 'lower',
  EXCLUDED = 'excluded',
}

export enum SchoolGradeScaleSize {
  FIVE = 5,
  SIX = 6,
}

export const MIN_GRADE_LEVELS = SchoolGradeScaleSize.FIVE;
export const MAX_GRADE_LEVELS = SchoolGradeScaleSize.SIX;
